import { TaskViewElementEnum } from '@/components/tasks-kanban/enums';

/**Модель элемента списка */
export class ListItemModel {
  /**Тип элемента */
  Type!: TaskViewElementEnum;
  /**Имя */
  Name!: string;
  /**Ширина элемента */
  Width!: string;
  /**Минимальная ширина элемента */
  MinWidth?: string;

  constructor(obj?: Partial<ListItemModel>) {
    if (obj) Object.assign(this, obj);
  }
}
